import { useEffect, useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { $enum } from "ts-enum-util";

import { useBlizzardEvents } from "../../../analytics/hooks";
import { useSelectedFeature } from "../../../shared/hooks/useSelectedFeature";
import { AbsoluteRoute } from "../absoluteRoutes";

export const usePageViewBlizzardEvent = (): void => {
    const location = useLocation();
    const matchedRoutes = useMemo(
        () =>
            $enum(AbsoluteRoute)
                .getValues()
                .filter((route: string) => matchPath({ path: route }, location.pathname)),
        [location.pathname],
    );

    const { sendBlizzardEvent } = useBlizzardEvents();

    const { selectedFeature } = useSelectedFeature();

    useEffect(() => {
        if (matchedRoutes.length > 0) {
            // get the longest matched route or the latest matched route
            const matchedRoute = matchedRoutes.reduce((a, b) => (a.split("/").length > b.split("/").length ? a : b));
            sendBlizzardEvent({
                event: "MYLENSES_PAGE_VIEW",
                path: matchedRoute,
                namespace: selectedFeature ?? matchedRoute.split("/")[1] ?? "",
            });
        }
    }, [matchedRoutes, sendBlizzardEvent, selectedFeature]);
};
